module.exports = __webpack_public_path__ + "static/media/elearning.57a56d43.svg";